// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3757":"90e32886","4818":"90e32886","5611":"90e32886","6215":"31d6cfe0"}[chunkId] + ".chunk.css";
};